/*
 * Lunch and dinner, told apart by colour.
 *
 * A factory runs two or three services a day and the difference between them
 * is the whole point of a row — miss it and somebody collects at noon for a
 * meal that arrives at six. The hues come from the palette rather than from a
 * new set: morning is the amber already used for warnings, midday is the
 * brand green, and evening is the near-black the app uses for night.
 */
const MEAL_TONE: Record<string, { chip: string; text: string }> = {
  breakfast: { chip: 'bg-warn-soft text-warn-ink', text: 'text-warn-ink' },
  lunch: { chip: 'bg-brand-soft text-brand-ink', text: 'text-brand-ink' },
  dinner: { chip: 'bg-panel-dark text-white', text: 'text-ink' },
};

export function mealTone(mealType: string): { chip: string; text: string } {
  return MEAL_TONE[mealType] ?? { chip: 'bg-neutral-soft text-neutral-ink', text: 'text-muted' };
}
